import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";

const STATUS_LABELS = {
  1: "Not Paid",
  2: "Paid",
  3: "Accepted",
  4: "In Transit",
  5: "Delivered",
  6: "Rejected",
  7: "Refunded",
  8: "Return Requested",
  9: "Return In Transit",
  10: "Returned",
  11: "Return Rejected"
};

export const OrdersPage = ({ fetchOrders, orders, isLoading }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <>
      <div className="full-row bg-light overlay-dark py-5"
        style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">User Orders</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <a href="#" className="text-white">Home</a>
                  </li>
                  <li className="breadcrumb-item active text-white" aria-current="page">User Orders</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <main>
        <div class="my-4 px-3" style={{ maxWidth: "1000px", margin: "auto" }}>
            <div class="container">
                <div class="row">
                    <div class="col-12 d-md-none mb-3">
                        <button class="btn btn-dark d-inline-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar" aria-controls="offcanvasSidebar">
                            <i class="bi bi-list"></i> Menu
                        </button>
                    </div>
            
                    <div className="offcanvas offcanvas-start d-md-none" id="offcanvasSidebar" tabIndex="-1" aria-labelledby="offcanvasSidebarLabel">
                        <div class="offcanvas-header">
                            <h5 class="offcanvas-title" id="offcanvasSidebarLabel">Dashboard</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div class="offcanvas-body">
                            <div class="box1-list">
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>Orders</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>Edit Profile</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/update-password")}>Change Passwords</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => {
                                    sessionStorage.removeItem("loggedUser");
                                    sessionStorage.removeItem("userToken");
                                    window.location.href = "/login"
                                }}>Logout</h6>
                            </div>
                        </div>
                    </div>
            
                    <div class="col-md-4 d-none d-md-block">
                        <div class="box1">
                            <div class="heading">
                                <h3 class="profile-heading">
                                    Orders
                                    <span style={{ display: "inline-block", borderBottom: "3px solid black", width: "12%", textAlign: "left", marginTop: "10px"}}>
                                    </span>
                                </h3>
                            </div>
                            <div class="box1-list">
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>Orders</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>Edit Profile</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/update-password")}>Change Passwords</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => {
                                    sessionStorage.removeItem("loggedUser");
                                    sessionStorage.removeItem("userToken");
                                    window.location.href = "/login"
                                }}>Logout</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <h3 class="profile-heading">Orders
                            <span style={{ display: "inline-block", borderBottom: "3px solid black", width: "6%", textAlign: "left", marginTop: "10px"}}>
                                    </span>
                        </h3>
                        {/* <div class="align-items-center upload-image">
                            <img src="./images/profile.jpg" alt="Profile Picture" class="rounded-circle img-thumbnail me-3" width="135px" />
                            <button class="btn btn-dark upload-btn">Upload</button>
                        </div> */}
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>#Order</th>
                                        <th>Date</th>
                                        <th>Order Total</th>
                                        <th>Order Status</th>
                                        <th>View Order</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(orders) && orders?.map(x => (
                                        <tr key={x?.id}>
                                            <td>#BH{x.id}</td>
                                            <td>{x.createdAt}</td>
                                            <td>₹{x?.finalAmount.toFixed(2)}</td>
                                            <td>{STATUS_LABELS[x?.status] || "Lost"}</td>
                                            <td><button class="btn btn-primary" onClick={() => navigate(`/order/${x?.id}`)}>View Order</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </>
  );
};
